/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.querySelector('.Drawer__Close').addEventListener('click', function(){
  // console.log('close!!');
  if(document.querySelector('.Drawer--small')){
    document.querySelector('.Drawer--small').setAttribute('aria-hidden','true');
  }
  document.querySelector('#sidebar-cart').setAttribute('aria-hidden','true');
  document.querySelector('.Search-new').style.zIndex = 10;
});
if(document.querySelector('.Header__page__Icon')){
  document.querySelector('.Header__page__Icon').addEventListener('click', function(event){
    event.preventDefault();
    document.querySelector('.PageOverlay').classList.add('hide-no-js')
  });
}


$(document).ready(function() { 
  $(".Skick").each(function(){
    var input_value = $(this).find(".SizeSwatch__Radio:checked").attr("data-value")
    $(".oprion_desc").each(function(){
      // $(this).removeClass("active");
      var descValue = $(this).attr("data-value")    
      if ( input_value == descValue ) {
        $(this).addClass("active");
      }
    });
  });


  $(".Skick").on("click", function(){
    var input_value = $(this).find(".SizeSwatch__Radio").val()
    $(".oprion_desc").each(function(){
      $(this).removeClass("active");
      var descValue = $(this).attr("data-value")    
      if ( input_value == descValue ) {
        $(this).addClass("active");
      }
    });
  });
  var vimpla_btn = document.querySelectorAll('.vimpla_btn')

  var height = $(window).height();
  if(height < 750 ){
    $('.content_popup .content_main .popup').addClass('min-700')
    $('.content_popup .content_main .popup .popup_content').addClass('min-700-content')
  }
  $('.vimpla_btn').on('click',function(){
    var data = $(this).attr('data-content');
    $('.content_popup').find('.popup_content').html(data)
    $('.content_popup').removeClass('d-none');
  });

  $('.close_popup').on('click',function(){
    $('.content_popup').find('.popup_content').html('')
    $('.content_popup').addClass('d-none');
  })
      $('.accessories_btn').click(function(e){
      e.preventDefault();
        var PDID = $(this).attr("data-var_id");

        // console.log(PDID)
        addItemtoCart( PDID, 1,this );    // paste your id product number
        $('.cart_dr').trigger( "click" );
      });
     
        function addItemtoCart(variant_id, qty,tag) {
        data = {
          "id": variant_id,
          "quantity": qty
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            $('#sidebar-cart').attr('aria-hidden','false');
            $('.PageOverlay').addClass('is-visible');
          },
          error:function(){
            var title = $(tag).closest('.ProductForm_addtocart').siblings('.ProductItem__Info').find('.ProductItem__Title.Heading a').text();
            var html = `<h1 class="ProductForm__Error Alert Alert--error side_error">${title} finns i din varukorg.</h1>`
            $(tag).closest('.ProductItem').append(html)
            $(tag).closest('.ProductItem').css('flex-direction','column')
            setTimeout(function(){$('.side_error').remove()},2000)
          }
        }); 
      }    
        $("#popupContent .ad_to_cart_coll").text("LÄGG TILL");
      
       $('.ad_to_cart_coll').click(function(e){
        e.preventDefault();
        var ID = $(this).attr("data-vari-id");
        addItemToCart( ID, 1,this );  
        $('.cart_dr').trigger( "click" );
          $(this).siblings('#message').text("Produkten har lagts till").show();
      });

      function addItemToCart(variant_id, qty,tag) {
        data = {
          "id": variant_id,
          "quantity": qty
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            $('#sidebar-cart').attr('aria-hidden','false');
            $('.PageOverlay').addClass('is-visible');
          },
          error:function(){
            var title = $(tag).closest('.ProductForm_addtocart').siblings('.ProductItem__Info').find('.ProductItem__Title.Heading a').text();
            var html = `<h1 class="ProductForm__Error Alert Alert--error side_error">${title} finns i din varukorg.</h1>`
            $(tag).closest('.ProductItem').append(html)
            $(tag).closest('.ProductItem').css('flex-direction','column')
            setTimeout(function(){$('.side_error').remove()},2000)
          }
        }); 
      }  

      $('.Drawer__Close').on('click', function(){
        $('.PageOverlay').removeClass('is-visible');
        //         $('.Drawer--small').attr('aria-hidden','true');
        $('#sidebar-cart').attr('aria-hidden','true');  
      });
      $('.PageOverlay').on('click', function(){
        $('#sidebar-cart').attr('aria-hidden','true'); 
        $('.PageOverlay').removeClass('is-visible');
      });
  
   var selectLength

    $('.product-select-v .variant_select').each((i,item)=>{
      selectLength = $(item).html().split('/');
    })

    if(selectLength){
    if(selectLength.length > 2){

      var flagClick = false;
      var clickDiv

      // This function is to fetch the data for the last option
      var colorActive = (disabled,available,select_option,swatchRadio,swatchColor) =>{
        var selectedFirst
        var selectedSecond
        var selectedThird
        $('.SizeSwatchList .SizeSwatchListli').removeClass('next_click');
        setTimeout(function(){
          $('.SizeSwatchList:eq(0) .SizeSwatchListli').each(function(k,li){
            if($(li).find('.SizeSwatch__Radio').prop("checked")){
              selectedFirst = $(li).find('.SizeSwatch__Radio').val()
            }
          });
          $('.SizeSwatchList:eq(1) .SizeSwatchListli').each(function(k,li){
            if($(li).find('.SizeSwatch__Radio').prop("checked")){
              selectedSecond = $(li).find('.SizeSwatch__Radio').val();
            }
          });
          $('.SizeSwatchList:eq(2) .SizeSwatchListli').each(function(k,li){
            if($(li).find('.SizeSwatch__Radio').prop("checked")){
              selectedThird = $(li).find('.SizeSwatch__Radio').val()
            }
          });
          $('.SizeSwatchList:eq(2) .SizeSwatchListli').each(function(i,item2){
            var colorFlag = $(item2).find('.SizeSwatch__Radio').val();
            if(select_option.includes(colorFlag)){
              $(this).addClass('active');
              if(disabled == 'disabled'){
                if((select_option.split('/')[2].split('-')[0].toLowerCase().trim() == colorFlag.toLowerCase().trim()) &&  select_option.includes(`${selectedFirst} / ${selectedSecond} / ${colorFlag}`)){
                  $(item2).addClass('cross_for_sold_out');  
                  $(item2).find("p.dis-price").addClass("deactives");
                }
              }else if(available == 'available'){
                if((select_option.split('/')[2].split('-')[0].toLowerCase().trim() == colorFlag.toLowerCase().trim()) &&  select_option.includes(`${selectedFirst} / ${selectedSecond} / ${colorFlag}`)){
                  $(item2).removeClass('cross_for_sold_out');
                  $(item2).find("p.dis-price").removeClass("deactives");
                  if($(item2).find('label').attr('data-tooltip')){
                    $(item2).addClass('next_click');
                  }else{
                    $(item2).addClass('currentSelected');
                  }
                }
              }
            }
          });
          if(flagClick){
              if($(swatchRadio).siblings('label').attr('data-tooltip')){
              }else{
                // Keep previously selected color stable when other options change.
                return false;
              }
          }
        },300);
          $('.SizeSwatchList').each(function(i,itemLi){
            if($(itemLi).find('.SizeSwatchListli').find('label').attr('data-tooltip')){
              $(itemLi).find('.SizeSwatchListli').each((j,item)=>{
                $(item).addClass('tooltip_hide');
              })
            }
          });
          setTimeout(function(){
          $('.SizeSwatchList').each(function(i,itemLi){
            $(itemLi).find('.SizeSwatchListli').each((j,item)=>{
              $(item).removeClass('tooltip_hide');
            })
          });
        },300);
      }

      var sizeActive = () => {
        $('.SizeSwatchList:eq(0) .SizeSwatchListli').each(function(i,itemLi){
           var sizevalue = $(this).find(".SizeSwatch .value").text();
          var flag = false;
          $('.variant_select').each(function(i,opt){
            var option = $(this).html();
            if(option.includes(sizevalue)){
              var optDisable = $(opt).attr('disabled');
              var optAvailbale = $(opt).attr('available');
              if(optDisable == 'disabled'){
              }
              if(optAvailbale == 'available'){
                flag = true;
              }
            }
          });
          if(flag){
            $(itemLi).removeClass('cross_for_sold_out');
            $(itemLi).find("p.dis-price").removeClass("deactives");
          }else{
            $(itemLi).addClass('cross_for_sold_out');
            $(itemLi).find("p.dis-price").addClass("deactives");
          }
        });
      }

      var urlChange = () => {
          var selectedVariant = $('.product-select-v').children("option:selected").val();
           var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          selectedVariant;
          window.history.replaceState({ path: newurl }, '', newurl);
      }

      // This function will match the condition and according to that it will work, Also fetch the data for the first option
      function variant_combination(swatch_value,real_swatch,swatchRadio,swatchColor){
        if(!swatchColor){
          $('.SizeSwatchListli').removeClass('cross_for_sold_out');
          $('.SizeSwatchListli').removeClass('next_click');
          $('.SizeSwatchListli').removeClass('active'); 
        }
        var swatchvalue = swatch_value;
        var selectedFirst1        
        var selectedFirst2
        var selectedFirst3

        $('.SizeSwatchList:eq(0) .SizeSwatchListli').each(function(k,li){
          if($(li).find('.SizeSwatch__Radio').prop("checked")){
            selectedFirst1 = $(li).find('.SizeSwatch__Radio').val()
          }
        });
        $('.SizeSwatchList:eq(1) .SizeSwatchListli').each(function(k,li){
          if($(li).find('.SizeSwatch__Radio').prop("checked")){
            selectedFirst2 = $(li).find('.SizeSwatch__Radio').val()
          }
        });
        $('.SizeSwatchList:eq(2) .SizeSwatchListli').each(function(k,li){
          if($(li).find('.SizeSwatch__Radio').prop("checked")){
            selectedFirst3 = $(li).find('.SizeSwatch__Radio').val()
          }
        });
        if(!swatchColor){
          $('.variant_select').each(function(i,item){
          if(this == 'selected'){
            var select_option = $(this).html();
          }
          var select_option = $(this).html();
          var split_value = select_option.split('/');
          var size_value = split_value[0].toLowerCase().trim();
          var conditionValue = split_value[1].toLowerCase().trim();
          var lastValue = split_value[2].split('-')[0].toLowerCase().trim()

          var range_value_select = split_value[1].split('-');
          var range_value = split_value[1].toLowerCase().trim();

          if (size_value == swatch_value){
            var attr = $(this).attr('disabled');
            var attrAvailbale = $(this).attr('available');

            // $('.SizeSwatchListli').each(function(i,item){
            //   var FindValue = $(this).find('.SizeSwatch__Radio').attr('value');
            //   var sizevalue = $(this).find('.SizeSwatch').html().toLowerCase().trim();
            //   if(sizevalue == range_value ){
            //     $(this).addClass('active');
            //     if(attr == 'disabled'){
            //       $(this).addClass('cross_for_sold_out');
            //     }
            //     if(attrAvailbale == 'available'){
            //       $(this).addClass('next_click');
            //       $(this).removeClass('cross_for_sold_out');
            //     }
            //   }
            // });
            var ua = navigator.userAgent.toLowerCase(); 
            if (ua.indexOf('safari') != -1) { 
              if (ua.indexOf('chrome') > -1) {
              } else {
                setTimeout(function(){
                  if(flagClick){
                    $(clickDiv).trigger('click'); 
                  }
                  return false;
                },10);
              }
            }
            colorActive(attr,attrAvailbale,select_option,swatchRadio,swatchColor);
            sizeActive();
          }   

          if (size_value == selectedFirst1.toLowerCase().trim()){
            var attr = $(this).attr('disabled');
            var attrAvailbale = $(this).attr('available');
            $('.SizeSwatchList:eq(0) .SizeSwatchListli').each(function(i,itemLi){
             var sizevalue = $(this).find(".SizeSwatch .value").text();
              var flag = false;
              $('.variant_select').each(function(i,opt){
                var option = $(this).html();
                if(option.includes(`${selectedFirst1} / ${sizevalue} `)){
                  var optDisable = $(this).attr('disabled');
                  var optAvailbale = $(this).attr('available');
                  if(optDisable == 'disabled'){
                  }
                  if(optAvailbale == 'available'){
                    flag = true;
                  }
                }
              });
              if(flag){
                if($(this).find('label').attr('data-tooltip')){
                  $(this).addClass('currentSelected');
                }else{
                  $(this).addClass('next_click');
                }
                $(itemLi).removeClass('cross_for_sold_out');
                $(itemLi).find("p.dis-price").removeClass("deactives");
              }else{
                $(itemLi).addClass('cross_for_sold_out');
                $(itemLi).find("p.dis-price").addClass("deactives");
              }
            });
            colorActive(attr,attrAvailbale,select_option,swatchRadio,swatchColor);
            sizeActive();
          }  

          if (conditionValue == selectedFirst2.toLowerCase().trim()){
            var attr = $(this).attr('disabled');
            var attrAvailbale = $(this).attr('available');
            $('.SizeSwatchList:eq(1) .SizeSwatchListli').each(function(i,itemLi){
             var sizevalue = $(this).find(".SizeSwatch .value").text();
              var flag = false;
              $('.variant_select').each(function(i,opt){
                var option = $(this).html();
                if(option.includes(`${selectedFirst1} / ${sizevalue} `)){
                  var optDisable = $(this).attr('disabled');
                  var optAvailbale = $(this).attr('available');
                  if(optDisable == 'disabled'){
                  }
                  if(optAvailbale == 'available'){
                    flag = true;
                  }
                }
              });
              if(flag){
                if($(itemLi).find('label').attr('data-tooltip')){
                  $(itemLi).addClass('currentSelected');
                }else{
                  $(itemLi).addClass('next_click');
                }
                $(itemLi).removeClass('cross_for_sold_out');
                 $(itemLi).find("p.dis-price").removeClass("deactives");
              }else{
                $(itemLi).addClass('cross_for_sold_out');
                $(itemLi).find("p.dis-price").addClass("deactives");
              }
            });  
            let clickedMainHead = $(swatchRadio).closest('.SizeSwatchList').attr('data-option');
            let mainHead = $('.SizeSwatchList:eq(1)').attr('data-option');

              
            // if(!$(swatchRadio).siblings('label').attr('data-tooltip')){
            //   // safari issue
            //   // Compared if clicked option is not color then this condition will run
            //   if(clickedMainHead == mainHead){
            //   }else{
            //     $('.SizeSwatchList:eq(1) .next_click').find('label').trigger('click');
            //     var ua = navigator.userAgent.toLowerCase(); 
            //     if (ua.indexOf('safari') != -1) { 
            //       if (ua.indexOf('chrome') > -1) {
            //       } else {
            //         $('.SizeSwatchList:eq(1) .next_click:eq(0)').find('label').trigger('click');
            //         $('.SizeSwatchList:eq(1) .next_click').find('label').trigger('click');
            //         setTimeout(function(){
            //           if(flagClick){
            //             setTimeout(function(){
            //               $('.SizeSwatchList:eq(1) li').not(".cross_for_sold_out").find('label').trigger('click');
            //               $('.SizeSwatchList:eq(1) li').not(".cross_for_sold_out").find('.SizeSwatch__Radio').prop("checked",true);
            //             },10)
            //           }
            //           return false;
            //         },10)
            //       }
            //     }
            //   }
            // }
        
            
          } 

          if (conditionValue == swatch_value){
            var attr2 = $(item).attr('disabled');
            var attrAvailbale2 = $(item).attr('available');
            colorActive(attr2,attrAvailbale2,select_option,swatchRadio,swatchColor);
            sizeActive();
          } 
        });
        }
       
      }
      var swatch_value = $('.SizeSwatch__Radio').attr('value').toLowerCase().trim();
      var real_swatch = $('.SizeSwatch__Radio').attr('value');
      var swatchColor = $('.SizeSwatch__Radio').siblings('label').attr('data-tooltip');
      if (!$('.ProductForm__Variants[data-disable-legacy-swatch-chain]').length) {
        variant_combination(swatch_value, real_swatch, $('.SizeSwatch__Radio'), swatchColor);
      }
      $('.SizeSwatch__Radio').click(function () {
        if ($(this).closest('.ProductForm__Variants[data-disable-legacy-swatch-chain]').length) {
          setTimeout(urlChange, 400);
          return;
        }
        let thisValue = $(this).val();
        let prevClicked = localStorage.getItem("clicked");
        var funcFlag = true
        if(thisValue == prevClicked){
          funcFlag = false;
        }
        flagClick  = true;
        var $click  = $(this);
        localStorage.setItem("clicked", $(this).val());
        var real_swatch = $(this).attr('value')
        var swatch_value = $(this).attr('value').toLowerCase().trim();
        clickDiv = $('.currentSelected').find('label');
        var swatchColor = $(this).siblings('label').attr('data-tooltip');
     if(funcFlag){
          variant_combination(swatch_value,real_swatch,$click,swatchColor);
          if($(this).siblings('label').attr('data-tooltip')){
            $('.SizeSwatchListli').removeClass('currentSelected');
            $(this).closest('.SizeSwatchListli').addClass('currentSelected');
            $('.currentSelected').find('label').trigger('click');
            $('.currentSelected').find('label').trigger('click');
          }
        }
         setTimeout(function(){
         var main_src = $(".Product__SlideItem.Product__SlideItem--image.Carousel__Cell.is-selected").find('img.active').attr("data-original-src");
         $(".ex-product").find('.freq_img').attr("srcset", main_src);
      },500);
         setTimeout(urlChange,400);
      });
    }else{
      function variant_combination2(swatch_value){
        $('.SizeSwatchListli').removeClass('cross_for_sold_out');
        $('.SizeSwatchListli').removeClass('next_click');
        $('.SizeSwatchListli').removeClass('active');
     var urlChange = () => {
          var selectedVariant = $('.product-select-v').children("option:selected").val();
           var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          selectedVariant;
          window.history.replaceState({ path: newurl }, '', newurl);
      }

        var swatchvalue = swatch_value;
        //var color = color;
        $('.variant_select').each(function(){
          var select_option = $(this).html();
          var split_value = select_option.split('/');
          var color_value = split_value[0].toLowerCase().trim();
          var size_value_select = split_value[1].split('-');
          var selectedFirst1  
          var selectedFirst2
          $('.SizeSwatchList:eq(0) .SizeSwatchListli').each(function(k,li){
            if($(li).find('.SizeSwatch__Radio').prop("checked")){
              selectedFirst1 = $(li).find('.SizeSwatch__Radio').val()
            }
          });
          $('.SizeSwatchList:eq(1) .SizeSwatchListli').each(function(k,li){
            if($(li).find('.SizeSwatch__Radio').prop("checked")){
              selectedFirst2 = $(li).find('.SizeSwatch__Radio').val()
            }
          });

          if(color_value == swatchvalue){
            var attr = $(this).attr('disabled');
            var size_value = split_value[1].split('-');
            var size_valuee = size_value[0].toLowerCase().trim();

            $('.SizeSwatchListli').each(function(){
            var sizevalue = $(this).find(".SizeSwatch .value").text();
              if(sizevalue == size_valuee )
              {	
                $(this).addClass('active');
                if(attr == 'disabled')
                {
                  $(this).addClass('cross_for_sold_out');
                  $(this).find("p.dis-price").addClass("deactives");
                }
                else{
                  $(this).addClass('next_click');
                }
              }
              //               $('.SizeSwatchList:eq(1) .next_click:eq(0)').find('label').trigger('click');
            });
            var ua = navigator.userAgent.toLowerCase(); 
            if (ua.indexOf('safari') != -1) { 
              if (ua.indexOf('chrome') > -1) {
              } else {
                setTimeout(function(){
                  if(flagClick){
                    $(clickDiv).trigger('click');
                    return false;
                  }
                },10);
              }
            }
          }
 
          var attr = $(this).attr('disabled');
          var attrAvailbale = $(this).attr('available');
          $('.SizeSwatchList:eq(1) .SizeSwatchListli').each(function(i,itemLi){
            var sizevalue = $(this).find(".SizeSwatch .value").text();
            var flag = false;
            $('.variant_select').each(function(i,opt){
              var option = $(this).html();
              if(option.includes(`${selectedFirst1} / ${sizevalue} `)){
                var optDisable = $(this).attr('disabled');
                var optAvailbale = $(this).attr('available');
                if(optDisable == 'disabled'){
                }
                if(optAvailbale == 'available'){
                  flag = true;
                }
              }
            });
            if(flag){
              $(itemLi).removeClass('cross_for_sold_out');
              $(itemLi).find("p.dis-price").removeClass("deactives");
            }else{
              $(itemLi).addClass('cross_for_sold_out');
              $(itemLi).find("p.dis-price").addClass("deactives");
            }
          });
        });
        setTimeout(urlChange,400);
      }
      var swatch_value = $('.selected_variant').attr('data-value').toLowerCase().trim();

      variant_combination2(swatch_value);
      $('.SizeSwatch__Radio').click(function(){
       
        flagClick  = true;
        var swatch_value = $(this).attr('data-value').toLowerCase().trim();
        variant_combination2(swatch_value);
        clickDiv = $('.next_click').find('label');

        var ua = navigator.userAgent.toLowerCase(); 
        if (ua.indexOf('safari') != -1) { 
          if (ua.indexOf('chrome') > -1) {
          } else {
            setTimeout(function(){
              if(flagClick){
                $('.next_click').find('label').trigger('click');
                return false;
              }
            },10)
          }
        }
       
      });
    }
    }
 
});

$(document).ready(function(){
   $.ajax({
    type: 'GET',
    url: '/cart.js',
    cache: false,
    dataType: 'json',
    success: function(data) {
      var single_id = data.items;
      var giftID = $("#free_vimlaproduct").attr("value");
      for(let i = 0; i < single_id.length; i++){
      var line_im = single_id[i];
      var line_id = line_im.id;
        if(giftID == line_id && single_id.length == 1){
          window.location = "cart/clear";
        }
      }
    }
   });
});

// =========================Product Page Variant Option selected change on click of add to cart============================
$('.ProductForm__AddToCart').click(function(){
    $('.SizeSwatch__Radio[name="option-1"]').each(function(){
        if($(this).is(':checked')){
            $('.SizeSwatch__Radio[name="option-1"]').removeAttr("checked");
            var checked_data = $(this).val();
            $('.SizeSwatch__Radio[name="option-1"][value="'+checked_data+'"]').attr("checked", "checked");
        }
    });
});
if($(".ProductForm__AddToCart").hasClass('Button--secondary')){
    $(".ProductItem__Available").addClass("show_error");
    $(".ProductItem__Image.small_image").addClass("op_false");
    $('.check').prop('disabled', true);
    setTimeout(syncPdpStickyAddToCart, 500);
 }
else{
   $(".ProductItem__Available").removeClass("show_error");
   $(".ProductItem__Image.small_image").removeClass("op_false");
   $('.check').prop('disabled', false);
}
$(document).ready(function() {
  $('.ProductItem__Wrapper.cusom_wrapper').each(function(){
   var onloadcheck  = $(this).find('input[type=radio]:first').prop('checked', true);    
  });
  $('.ProductItem__Wrapper.main_wrapper').each(function(){
   var onloadcheckother  = $(this).find('input[type=radio]:first').prop('checked', true);
  });
 setTimeout(function(){
   var main_src = $(".Product__SlideItem.Product__SlideItem--image.Carousel__Cell.is-selected").find('img.active').attr("data-original-src");
   var mob =  $(".ex-product").find('.freq_img').attr("srcset", main_src);
  },500);
     var checkedValue = $('.check:checked');
     $('.add_to_cart').prop('disabled', false);
    
    
 
    $(".add_to_cart").removeClass('Button--secondary');
    $(".add_to_cart").addClass('Button--primary');
  $('.ColorSwatch__Radio.custom_radio').each(function() {
    $(this).click(function(){
      var imageURL = $(this).attr("data-image-url");
      var variantUrl = $(this).attr("data-variant-url");      
      var variantID = $(this).attr("data-variant_id");      
      $(this).parents('.ProductItem__Wrapper.cusom_wrapper').find("img.small_image").attr("srcset" , imageURL );
      $(this).parents('.ProductItem__Wrapper.cusom_wrapper').find(".custom_pro_wrap").attr("data-vari-id" , variantID );
      $(this).parents('.ProductItem__Wrapper.cusom_wrapper').find(".check").attr("data-vari-id" , variantID );   
    });
  });
  $('.ColorSwatch__Radio.main_radio').each(function() {
    $(this).click(function(){      
       var imageURLM = $(this).attr("data-image-url");
       var variantUrlM = $(this).attr("data-variant-url");
       var variantIDM = $(this).attr("data-variant_id")
       $(this).parents('.ProductItem__Wrapper.main_wrapper').find("img.main_small").attr("srcset" , imageURLM );
       $(this).parents('.ProductItem__Wrapper.main_wrapper').find(".custom_pro_wrap_main").attr("data-vari-id" , variantIDM );
       $(this).parents('.ProductItem__Wrapper.main_wrapper').find(".ad_to_cart_coll").attr("data-vari-id" , variantIDM );
    })
  });
});
$(document).on('click', '.add_to_cart', function () {
    // Check if the Vimla subscription checkbox is checked
    if ($('#vimla_subscription').is(':checked') || $('#unsubscrib_checkbox').is(':checked')) {
        // If checked, trigger the click event on the Vimla button
        $('.Vimla_button.vimla_btn.Button.Button--full.Button--primary.Button--hide.Button--show').trigger('click').addclass('Button--show').css('display', 'block'); 
    } else {
        // If not checked, trigger the click event on the AddToCart button
        $(".ProductForm__AddToCart").trigger("click");
    }

    $('.Vimla_button').removeClass('Button--show');

    var checkedValue = $('.check:checked');
    var items = [];
    checkedValue.each(function () {
        var attr = $(this).attr("data-vari-id");
        if (typeof attr !== 'undefined' && attr !== false) {
            var variant_ID = $(this).attr("data-vari-id");
            items.push(variant_ID);
        }
    });

    $.ajax({
        type: 'GET',
        url: '/cart/add.js',
        cache: false,
        data: {
            id: items,
        },
        dataType: 'json',
        success: function (res) {
            $.getJSON('/cart.js', function (data) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {}));
            });
        }
    });
});



$(document).on('click','.check',function(){
  var checkedValue = $('.check:checked');
  if(checkedValue.length==0){
    $('.add_to_cart').prop('disabled', true);
    var btn3 =  $('.add_to_cart').attr('attr3');
    // console.log(btn3, "btn3");
    $(".add_to_cart").text(btn3);
     $(".add_to_cart").removeClass('Button--primary');
     $(".add_to_cart").addClass('Button--secondary');
    $(".add-on").css("display", "block");
 }
  else{
     $('.add_to_cart').prop('disabled', false);
    
    
    num = checkedValue.length + 1;
    num_str = num.toString();
    
    $(".add_to_cart").text(str);
    $(".add_to_cart").removeClass('Button--secondary');
    $(".add_to_cart").addClass('Button--primary');
    $(".add-on").css("display", "none");
  }
 });
$(document).on('click','.Product__SlideshowNavArrow, .dot',function(){
        setTimeout(function(){
             var main_src = $(".Product__SlideItem.Product__SlideItem--image.Carousel__Cell.is-selected").find('img.active').attr("data-original-src");
             $(".ex-product").find('.freq_img').attr("srcset", main_src);
        },500);
 });
 var discountElement = $('.ProductMeta__PriceList.Heading.test .discount');
var price = discountElement.length > 0 ? discountElement.text() : $('.ProductForm .Price--highlight .money').text();
$.trim(price);
 $('.custom_upsel_products_price').text(price);

 function formatVariantTitleForUi(rawTitle) {
   var t = (rawTitle || '').toString();
   t = t.replace(/\s*,\s*/g, ' | ');
   t = t.replace(/\s+skick\b/gi, '');
   return t.trim();
 }

 function syncPdpStickyAddToCart() {
   var $mainBtn = $('.ProductForm__BuyButtons .ProductForm__AddToCart');
   var $sticky = $('.desktop-sticky .add_to_cart, .desktop-sticky .quick_add_to_cart_btn');
   if (!$sticky.length) return;

   var soldOutLabel = (window.languages && window.languages.productFormSoldOut) || 'Tillfälligt slut';
   var addLabel = (window.languages && window.languages.productFormAddToCart) || 'Köp';
   var unavailable = !$mainBtn.length || $mainBtn.prop('disabled');

   if (unavailable) {
     $sticky.prop('disabled', true);
     $sticky.removeClass('Button--primary').addClass('Button--secondary');
     $sticky.text(soldOutLabel);
     return;
   }

   var checkedValue = $('.check:checked');
   $sticky.prop('disabled', false);
   $sticky.removeClass('Button--secondary').addClass('Button--primary');

   if (checkedValue.length === 0) {
     $sticky.each(function () {
       var btn3 = $(this).attr('attr3');
       $(this).text(btn3 || addLabel);
     });
   } else if (typeof str !== 'undefined') {
     $sticky.text(str);
   }
 }

 function syncPdpStickyPrice(variant) {
   var selectedVariantId = $('.product-select-v[name="id"]').val();
   if (!selectedVariantId) {
     selectedVariantId = $('.ProductForm__Variants input[name="id"]').val();
   }
   var variants = window.KlarnaThemeGlobals && window.KlarnaThemeGlobals.productVariants;
   if (selectedVariantId && Array.isArray(variants)) {
     var selectedVariant = variants.find(function (item) {
       return String(item.id) === String(selectedVariantId);
     });
     if (selectedVariant) variant = selectedVariant;
   }
   var price = variant && variant.price != null ? Number(variant.price) : NaN;
   if (!isFinite(price) || price <= 0) {
     var mainPriceElement = document.querySelector('.ProductMeta__PriceList [data-main-price]');
     var mainPrice = mainPriceElement && Number(mainPriceElement.getAttribute('data-price-cents'));
     if (!isFinite(mainPrice) || mainPrice <= 0) return;
     price = mainPrice;
   }
  var compareAtPrice = Number((variant && variant.compare_at_price) || 0);
   var hasDiscount = compareAtPrice > price;
   var formattedPrice;
   var formattedCompareAtPrice;

   if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
     formattedPrice = window.Shopify.formatMoney(price, window.theme.moneyFormat);
     formattedCompareAtPrice = window.Shopify.formatMoney(compareAtPrice, window.theme.moneyFormat);
   } else {
     formattedPrice = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(price / 100) + ' kr';
     formattedCompareAtPrice = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(compareAtPrice / 100) + ' kr';
   }

   $('.desktop-sticky [data-sticky-sale-price]').html(formattedPrice);
   $('.desktop-sticky [data-sticky-compare-price]').html(formattedCompareAtPrice);
   $('.desktop-sticky [data-sticky-sale-wrapper]').toggle(hasDiscount);
   $('.desktop-sticky [data-sticky-compare-wrapper]').toggle(hasDiscount);
   $('.desktop-sticky [data-sticky-regular-price]').html(formattedPrice).toggle(!hasDiscount);
 }

 document.addEventListener('variant:changed', function (event) {
   var variant = event && event.detail && event.detail.variant;
   setTimeout(function () {
     var pro_title = $('.product-select-v option:selected').attr('data-variant-title');
     var formatted_pro_title = formatVariantTitleForUi(pro_title);
     $('.var_title').text(formatted_pro_title);
     $('.var_titless').text(formatted_pro_title);
     syncPdpStickyPrice(variant);
     syncPdpStickyAddToCart();
   }, 0);
   setTimeout(function () { syncPdpStickyPrice(variant); }, 80);
   setTimeout(syncPdpStickyAddToCart, 120);
   setTimeout(syncPdpStickyAddToCart, 520);
 });

 var pro_title = $('.product-select-v option:selected').attr('data-variant-title');
var formatted_pro_title = formatVariantTitleForUi(pro_title);
$('.var_title').text(formatted_pro_title);




   $(".frequently .euro-price-change").addClass('display-none');
   $(".frequently .euro-price-change-compare").addClass('display-none');

var co_price = $('.ProductForm .Price--compareAt .money').text();
$('.c_price').text(co_price);

$(document).on("click", ".SizeSwatch__Radio, .Product__SlideshowNavArrow, .dot", function() {
    var item_not_available = $(this).parent('.cross_for_sold_out');
    if (item_not_available.length) {
        $('.check').prop('disabled', true);
    } else {
        $('.check').prop('disabled', false);
    }
    setTimeout(function() {
      syncPdpStickyPrice();
        var pro_title = $('.product-select-v option:selected').attr('data-variant-title');
        var formatted_pro_title = formatVariantTitleForUi(pro_title);
        $('.var_title').text(formatted_pro_title);
        $('.var_titless').text(formatted_pro_title);
        syncPdpStickyAddToCart();
    }, 500);
});

$(document).ready(function () {
  $(".SizeSwatchListli label").click(function () {
    $(".SizeSwatchListli label").removeClass("selected_variant");
    $(this).addClass("selected_variant");
  });
});

$(document).ready(function () {
  adjustSectionHeight(".shopify-section", ".fixheight.ProductItem__ImageWrapper");
  adjustSectionHeight(".shopify-section", ".two-feature-product a.FeaturedProduct__Gallery");
  adjustSectionHeight(".shopify-section", ".fixheight.ProductItem__Title");
  adjustSectionHeight(".shopify-section", ".two-feature-product h1.ProductMeta__Title.Heading.u-h2");
  adjustSectionHeight(".shopify-section", ".fixheight.custom-product-card-item");
});

// Variant image swatches (PDP)
(function () {
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function setSelectedColorImage(optionPosition, colorValue) {
    var pos = String(optionPosition);
    document.querySelectorAll('[data-variant-color-image][data-option-position="' + pos + '"]').forEach(function (btn) {
      var isSelected = String(btn.getAttribute('data-color-value')) === String(colorValue);
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function updateColorImageAvailability(scopeRoot) {
    var root = scopeRoot || document;
    root.querySelectorAll('[data-variant-color-image]').forEach(function (btn) {
      btn.classList.remove('is-soldout');
      var stock = btn.getAttribute('data-color-any-available');
      if (stock === 'true' || stock === 'false') {
        btn.classList.toggle('is-color-fully-soldout', stock === 'false');
      }
    });
  }

  function selectSwatchForColor(buttonEl) {
    var optionPosition = buttonEl.getAttribute('data-option-position');
    var colorValue = buttonEl.getAttribute('data-color-value');
    if (!optionPosition || !colorValue) return;

    var scope = buttonEl.closest('.ProductForm__Option') || document;
    var selector =
      'input.SizeSwatch__Radio[data-option-position="' +
      cssEscape(optionPosition) +
      '"][value="' +
      cssEscape(colorValue) +
      '"]';

    var input = scope.querySelector(selector);
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(syncPdpStickyAddToCart, 0);
      setTimeout(syncPdpStickyAddToCart, 150);
      setTimeout(syncPdpStickyAddToCart, 550);
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant) return;
    if (Array.isArray(variant.options)) {
      // Update for any option positions that have a color image list rendered
      document.querySelectorAll('[data-variant-color-image-list][data-option-position]').forEach(function (list) {
        var pos = Number(list.getAttribute('data-option-position'));
        if (!pos || !variant.options[pos - 1]) return;
        setSelectedColorImage(pos, variant.options[pos - 1]);
      });
    }
    // Run twice to stay in sync with async variant option updates from existing theme scripts.
    setTimeout(function () {
      updateColorImageAvailability(document);
    }, 20);
    setTimeout(function () {
      updateColorImageAvailability(document);
    }, 120);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-variant-color-image]');
    if (!btn) return;
    e.preventDefault();
    selectSwatchForColor(btn);
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Initial sync from checked swatch inputs
    document.querySelectorAll('.ProductForm__Option .SizeSwatchList.color').forEach(function (swatchList) {
      var checked = swatchList.querySelector('input.SizeSwatch__Radio:checked');
      if (!checked) return;
      var pos = checked.getAttribute('data-option-position');
      var value = checked.value;
      if (pos && value) setSelectedColorImage(pos, value);
    });
    updateColorImageAvailability(document);
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('input.SizeSwatch__Radio[data-option-position]')) return;
    setTimeout(function () {
      updateColorImageAvailability(document);
    }, 10);
  });
})();

// Product price UI sync (main price, compare price, discount %, static label)
(function () {
  var lastKnownVariant = null;

  function formatMoneyFromCents(cents) {
    var amount = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(amount, window.theme.moneyFormat);
    }

    try {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        maximumFractionDigits: 0
      }).format(amount / 100);
    } catch (e) {
      return String((amount / 100).toFixed(0)) + ' kr';
    }
  }

  function calculateDiscountPercent(priceCents, compareAtCents) {
    var price = Number(priceCents || 0);
    var compareAt = Number(compareAtCents || 0);
    if (!compareAt || compareAt <= 0 || compareAt <= price) return null;
    return Math.round(((compareAt - price) / compareAt) * 100);
  }

  function ensurePriceMarkup(priceList) {
    if (!priceList) return null;

    var mainPrice = priceList.querySelector('[data-main-price]');
    var compareRow = priceList.querySelector('[data-compare-row]');
    var comparePrice = priceList.querySelector('[data-compare-price]');
    var discountPct = priceList.querySelector('[data-discount-pct]');
    var helloText = priceList.querySelector('[data-price-hello]');

    if (!mainPrice || !compareRow || !comparePrice || !discountPct || !helloText) {
      var compareLabel = priceList.getAttribute('data-currency') || '';
      priceList.innerHTML = ''
        + '<div class="ProductMeta__PriceRow">'
        + '  <span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-main-price></span>'
        + '  <span class="ProductMeta__PriceMetaText Text--subdued" data-price-hello>Inkl. moms</span>'
        + '</div>'
        + '<div class="ProductMeta__CompareRow is-hidden" data-compare-row>'
        + '  <span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-compare-price>'
        + (compareLabel ? '<span class="price-test">' + compareLabel + '</span>&nbsp;' : '')
        + '  </span>'
        + '  <span class="ProductMeta__DiscountPct Text--subdued" data-discount-pct></span>'
        + '</div>';
    }

    return {
      mainPrice: priceList.querySelector('[data-main-price]'),
      compareRow: priceList.querySelector('[data-compare-row]'),
      comparePrice: priceList.querySelector('[data-compare-price]'),
      discountPct: priceList.querySelector('[data-discount-pct]'),
      helloText: priceList.querySelector('[data-price-hello]')
    };
  }

  function updateProductPriceUI(variant) {
    if (!variant) return;
    lastKnownVariant = variant;

    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    var discountPct = calculateDiscountPercent(price, compareAt);
    var hasDiscount = discountPct !== null;

    document.querySelectorAll('.ProductMeta__PriceList').forEach(function (priceList) {
      var nodes = ensurePriceMarkup(priceList);
      if (!nodes) return;

      nodes.mainPrice.innerHTML = formatMoneyFromCents(price);
      nodes.mainPrice.setAttribute('data-price-cents', price);
      nodes.helloText.textContent = 'Inkl. moms';
      nodes.compareRow.classList.toggle('is-hidden', !hasDiscount);

      if (hasDiscount) {
        var compareLabel = priceList.getAttribute('data-currency') || '';
        var labelHtml = compareLabel ? '<span class="price-test">' + compareLabel + '</span>&nbsp;' : '';
        nodes.comparePrice.innerHTML = labelHtml + formatMoneyFromCents(compareAt);
        nodes.discountPct.textContent = '(-' + discountPct + '%)';
      } else {
        nodes.comparePrice.innerHTML = '';
        nodes.discountPct.textContent = '';
      }
    });
  }

  function observePriceListReplacements() {
    document.querySelectorAll('.ProductMeta__PriceList').forEach(function (priceList) {
      if (priceList.__priceUiObserverAttached) return;
      priceList.__priceUiObserverAttached = true;

      var observer = new MutationObserver(function () {
        if (lastKnownVariant) {
          updateProductPriceUI(lastKnownVariant);
        }
      });
      observer.observe(priceList, { childList: true });
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant) return;
    // Run after theme variant handlers to avoid stale/overwritten values.
    setTimeout(function () {
      updateProductPriceUI(variant);
    }, 0);
    setTimeout(function () {
      updateProductPriceUI(variant);
    }, 80);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var selectedInput = document.querySelector('input[name="id"][value]');
    if (selectedInput) {
      var variantId = Number(selectedInput.value);
      var variants = window.KlarnaThemeGlobals && window.KlarnaThemeGlobals.productVariants;
      if (Array.isArray(variants)) {
        var current = variants.find(function (v) { return Number(v.id) === variantId; });
        if (current) updateProductPriceUI(current);
      }
    }
    observePriceListReplacements();
  });
})();

// Block variant buttons: ✓ when selected, "I lager" / sold-out label when not (matches PDP design)
(function () {
  function getVariants() {
    var variants = window.KlarnaThemeGlobals && window.KlarnaThemeGlobals.productVariants;
    return Array.isArray(variants) ? variants : [];
  }

  function getSelectedOptionsMap(scope) {
    var selected = {};
    (scope || document).querySelectorAll('input.SizeSwatch__Radio[data-option-position]:checked').forEach(function (input) {
      var pos = Number(input.getAttribute('data-option-position'));
      if (!pos) return;
      selected[pos] = String(input.value || '');
    });
    return selected;
  }

  function variantMatchesOptionValue(variant, optionPos, optionValue, selectedOptions) {
    if (!variant || String(variant['option' + optionPos]) !== String(optionValue)) return false;
    for (var posStr in selectedOptions) {
      if (!Object.prototype.hasOwnProperty.call(selectedOptions, posStr)) continue;
      var pos = Number(posStr);
      if (!pos || pos === Number(optionPos)) continue;
      var val = selectedOptions[pos];
      if (!val) continue;
      if (String(variant['option' + pos]) !== String(val)) return false;
    }
    return true;
  }

  function sanitizeStatusLabel(raw, fallback) {
    var s = (raw || '').trim();
    if (!s || s.indexOf('Translation missing') !== -1) return fallback;
    return s;
  }

  function getOptionLabels() {
    var wrap = document.querySelector('.ProductForm__Variants[data-variant-option-in-stock]');
    return {
      inStock: sanitizeStatusLabel(wrap && wrap.getAttribute('data-variant-option-in-stock'), 'In stock'),
      soldOut: sanitizeStatusLabel(wrap && wrap.getAttribute('data-variant-option-sold-out'), 'Sold out')
    };
  }

  function getOptionKindFromList(ul) {
    if (!ul) return 'other';
    if (ul.classList.contains('color')) return 'color';
    var name = (ul.getAttribute('data-option') || '').toLowerCase();
    if (!name) return 'other';
    var colorHints = ['color', 'colour', 'färg', 'farve', 'couleur', 'colore', 'farbe'];
    for (var ci = 0; ci < colorHints.length; ci++) {
      if (name.indexOf(colorHints[ci]) !== -1) return 'color';
    }
    if (/\d+\s*(gb|tb)\b/i.test(name)) return 'capacity';
    var capHints = ['capacity', 'storage', 'minne', 'lagring', 'kapacitet', 'memory'];
    for (var ki = 0; ki < capHints.length; ki++) {
      if (name.indexOf(capHints[ki]) !== -1) return 'capacity';
    }
    var condHints = ['condition', 'skick', 'cosmetic', 'slitage', 'premium', 'begagnad', 'refurbished'];
    for (var di = 0; di < condHints.length; di++) {
      if (name.indexOf(condHints[di]) !== -1) return 'condition';
    }
    return 'other';
  }

  function applyCombinationDisables(form, variants) {
    var selectedOptions = getSelectedOptionsMap(form);
    form.querySelectorAll('ul.SizeSwatchList[data-option]').forEach(function (ul) {
      var kind = getOptionKindFromList(ul);
      if (kind === 'color') {
        ul.querySelectorAll('input.SizeSwatch__Radio[data-option-position]').forEach(function (input) {
          input.disabled = false;
          var li = input.closest('li.SizeSwatchListli');
          if (li) li.classList.remove('is-combination-unavailable');
        });
        return;
      }
      if (kind !== 'capacity' && kind !== 'condition') return;

      ul.querySelectorAll('input.SizeSwatch__Radio[data-option-position]').forEach(function (input) {
        var pos = Number(input.getAttribute('data-option-position'));
        if (!pos) return;
        var val = String(input.value || '');
        var exists = variants.some(function (variant) {
          return variantMatchesOptionValue(variant, pos, val, selectedOptions);
        });
        input.disabled = !exists;
        var li = input.closest('li.SizeSwatchListli');
        if (li) li.classList.toggle('is-combination-unavailable', !exists);
      });
    });
  }

  function fixCheckedDisabledOptions(form) {
    var changed = false;
    form.querySelectorAll('ul.SizeSwatchList[data-option]').forEach(function (ul) {
      var kind = getOptionKindFromList(ul);
      if (kind !== 'capacity' && kind !== 'condition') return;
      var checked = ul.querySelector('input.SizeSwatch__Radio[data-option-position]:checked');
      if (!checked || !checked.disabled) return;
      var firstOk = ul.querySelector('input.SizeSwatch__Radio[data-option-position]:not(:disabled)');
      if (firstOk) {
        firstOk.click();
        changed = true;
      }
    });
    return changed;
  }

  function updateCombinationMatrix() {
    var variants = getVariants();
    if (!variants.length) return;
    document.querySelectorAll('.ProductForm__Variants[data-disable-legacy-swatch-chain]').forEach(function (root) {
      var form = root.closest('form');
      if (!form) return;
      var n = 0;
      while (n++ < 10) {
        applyCombinationDisables(form, variants);
        if (!fixCheckedDisabledOptions(form)) break;
      }
    });
  }

  function updateBlockVariantOptionStatuses() {
    updateCombinationMatrix();

    var variants = getVariants();
    var labels = getOptionLabels();
    if (!variants.length) return;

    document.querySelectorAll('.ProductForm__Variants .SizeSwatchList.has-variant-option-status').forEach(function (ul) {
      var form = ul.closest('form') || document;
      var selectedOptions = getSelectedOptionsMap(form);

      ul.querySelectorAll('li.SizeSwatchListli').forEach(function (li) {
        var input = li.querySelector('input.SizeSwatch__Radio[data-option-position]');
        if (!input) return;
        var pos = Number(input.getAttribute('data-option-position'));
        var val = String(input.value || '');
        var statusEl = li.querySelector('[data-variant-block-status]');
        if (!statusEl) return;

        var iconEl = statusEl.querySelector('[data-variant-block-status-icon]');
        var textEl = statusEl.querySelector('[data-variant-block-status-text]');
        var isSelected = input.checked;

        if (input.disabled) {
          li.classList.add('is-combination-unavailable');
          li.classList.remove('is-option-available', 'is-option-soldout', 'is-option-selected');
          if (iconEl) iconEl.setAttribute('hidden', '');
          if (textEl) {
            textEl.textContent = '';
            textEl.setAttribute('hidden', '');
            textEl.setAttribute('aria-hidden', 'true');
          }
          return;
        }

        li.classList.remove('is-combination-unavailable');

        var hasAvailable = variants.some(function (variant) {
          return Boolean(variant.available) && variantMatchesOptionValue(variant, pos, val, selectedOptions);
        });

        li.classList.toggle('is-option-selected', isSelected);
        li.classList.toggle('is-option-available', hasAvailable && !isSelected);
        li.classList.toggle('is-option-soldout', !hasAvailable && !isSelected);

        if (isSelected) {
          if (iconEl) {
            iconEl.textContent = '';
            iconEl.setAttribute('hidden', '');
          }
          if (textEl) {
            textEl.textContent = '';
            textEl.setAttribute('hidden', '');
            textEl.setAttribute('aria-hidden', 'true');
          }
        } else if (hasAvailable) {
          if (iconEl) iconEl.setAttribute('hidden', '');
          if (textEl) {
            textEl.textContent = labels.inStock;
            textEl.removeAttribute('hidden');
            textEl.removeAttribute('aria-hidden');
          }
        } else {
          if (iconEl) iconEl.setAttribute('hidden', '');
          if (textEl) {
            textEl.textContent = labels.soldOut;
            textEl.removeAttribute('hidden');
            textEl.removeAttribute('aria-hidden');
          }
        }
      });
    });
  }

  document.addEventListener('variant:changed', function () {
    setTimeout(updateBlockVariantOptionStatuses, 0);
    setTimeout(updateBlockVariantOptionStatuses, 80);
    setTimeout(updateBlockVariantOptionStatuses, 160);
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('input.SizeSwatch__Radio[data-option-position]')) return;
    setTimeout(updateBlockVariantOptionStatuses, 0);
    setTimeout(syncPdpStickyAddToCart, 0);
    setTimeout(syncPdpStickyAddToCart, 200);
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateBlockVariantOptionStatuses();
  });
})();

$(window).resize(function () {
  adjustSectionHeight(".shopify-section", ".fixheight.ProductItem__ImageWrapper");
  adjustSectionHeight(".shopify-section", ".two-feature-product a.FeaturedProduct__Gallery");
  adjustSectionHeight(".shopify-section", ".fixheight.ProductItem__Title");
    adjustSectionHeight(".shopify-section", ".two-feature-product h1.ProductMeta__Title.Heading.u-h2");
    adjustSectionHeight(".shopify-section", ".fixheight.custom-product-card-item");
});

$(window).on("load", function () {
   adjustSectionHeight(".shopify-section", ".fixheight.ProductItem__ImageWrapper");
  adjustSectionHeight(".shopify-section", ".two-feature-product a.FeaturedProduct__Gallery");
  adjustSectionHeight(".shopify-section", ".fixheight.ProductItem__Title");
    adjustSectionHeight(".shopify-section", ".two-feature-product h1.ProductMeta__Title.Heading.u-h2");
    adjustSectionHeight(".shopify-section", ".fixheight.custom-product-card-item");
});



function adjustSectionHeight(sectionSelector, elementSelector) {
  $(sectionSelector).each(function () {
    var section = $(this);
    var elements = section.find(elementSelector);
    elements.height("auto");
    var heightArray = [];
    elements.each(function () {
      var h = $(this).outerHeight();
      heightArray.push(h);
    });
    var maxHeight = Math.max.apply(Math, heightArray);
    elements.height(maxHeight);
  });
}


var currentURL = window.location.href;

if (currentURL.includes("/product")) {
  $(document).on("click", ".Product__SlideshowNavArrow, .dot", function(e) {
    e.stopPropagation();
    $(".text").removeClass("active");
    $(".text").addClass("deactive");
    $(".block").removeClass("deactive");
    $(".block").addClass("active");
  });

  const dotContainer = document.querySelector('.flickity-page-dots');
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.attributeName === 'class') {
        const selectedButton = dotContainer.querySelector('.dot.is-selected');
        if (selectedButton) {
          selectedButton.click();
        }
      }
    }
  });
observer.observe(dotContainer, { attributes: true, childList: true, subtree: true });}

var currentURL = window.location.href;
if (currentURL.includes("product") && currentURL.includes("renewed.se")) {
$(document).ready(function () {
  function triggerClickIfMatch() {
  var allElementsWithDataValue = $('label.SizeSwatch[data-color]');
    var allDataValues = allElementsWithDataValue.map(function () {
      return $(this).data('color');
    }).get();
    var selectedElement = $('.Product__SlideItem.is-selected');
    if (selectedElement.length > 0) {
      var dataAltValue = selectedElement.data('alt');
      var matchingColor = allDataValues.find(function (color) {
        return dataAltValue.includes(color);
      });
      if (matchingColor) {
        var elementToClick = $('label.SizeSwatch[data-color="' + matchingColor + '"]');
        if (elementToClick.length > 0) {
          elementToClick.click();
        }
      } 
    }
  }
  setInterval(triggerClickIfMatch, 500);
});
}
var currentURL = window.location.href;
if (currentURL.includes("product") && currentURL.includes("renewed.se")) {
// Get the parent div element
const parentDiv = document.querySelector('.ProductMeta__PriceList');

// Check if it contains a child element with the class 'discount'
if (parentDiv.querySelector('.discount')) {
    // Add the 'flex' class to the parent div
    parentDiv.classList.add('flex');
}
}

// Product thumbnail slider controls (desktop): show 4 at a time with prev/next.
(function () {
  var DESKTOP_WIDTH = 1140;

 function createButton(direction) {
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ProductThumbSliderBtn ProductThumbSliderBtn--' + direction;
  btn.setAttribute('aria-label', direction === 'prev' ? 'Previous thumbnails' : 'Next thumbnails');

  // Define the SVG paths for a clean, thin chevron
  const upChevron = `<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 11L10 2L19 11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>`;
                    
  const downChevron = `<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 1L10 10L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      </svg>`;

  // Assign the correct SVG based on direction
  btn.innerHTML = direction === 'prev' ? upChevron : downChevron;

  return btn;
}

  function updateButtons(scroller, prevBtn, nextBtn) {
    var maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
    prevBtn.disabled = scroller.scrollTop <= 1;
    nextBtn.disabled = scroller.scrollTop >= (maxScroll - 1);
  }

  function setupOne(navEl) {
    if (!navEl || navEl.__thumbSliderInit) return; 
    var scroller = navEl.querySelector('.Product__SlideshowNavScroller');
    if (!scroller) return;

    var items = scroller.querySelectorAll('.Product__SlideshowNavImage');
    if (!items.length) return;

    var prevBtn = createButton('prev');
    var nextBtn = createButton('next');
    navEl.appendChild(prevBtn);
    navEl.appendChild(nextBtn);

    function getStep() {
      var firstItem = scroller.querySelector('.Product__SlideshowNavImage');
      if (!firstItem) return 80;
      var itemStyle = window.getComputedStyle(firstItem);
      var marginBottom = parseFloat(itemStyle.marginBottom || '0') || 0;
      return Math.ceil(firstItem.getBoundingClientRect().height + marginBottom + 10);
    }

    function applyViewportHeight() {
      if (window.innerWidth < DESKTOP_WIDTH) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        scroller.style.maxHeight = '';
        return;
      }
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      var step = getStep();
      scroller.style.maxHeight = (step * 4 - 10) + 'px';
      updateButtons(scroller, prevBtn, nextBtn);
    }

    prevBtn.addEventListener('click', function () {
      var step = getStep();
      scroller.scrollBy({ top: -step, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      var step = getStep();
      scroller.scrollBy({ top: step, behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', function () {
      updateButtons(scroller, prevBtn, nextBtn);
    });

    window.addEventListener('resize', applyViewportHeight);
    setTimeout(applyViewportHeight, 0);
    navEl.__thumbSliderInit = true;
  }

  function initThumbSliders() {
    document.querySelectorAll('.template-product .Product__SlideshowNav--thumbnails').forEach(setupOne);
  }

  document.addEventListener('DOMContentLoaded', initThumbSliders);
  document.addEventListener('variant:changed', function () {
    setTimeout(initThumbSliders, 0);
  });
})();

